import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textTypes from './textTypes';
var TextLabel = function TextLabel(props) {
  var classList = ['control-label-base'];
  if (props.type) {
    classList.push(_.toLower(props.type));
  }
  if (props.disabled) {
    classList.push('disabled');
  }
  return /*#__PURE__*/React.createElement('span', {
    className: props.getClassName(classList.join(' ')),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.translateIfNeeded(props.value));
};
TextLabel.displayName = displayNames.TEXT_LABEL_BASE;
TextLabel.propTypes = {
  value: PropTypes.string.isRequired,
  type: PropTypes.oneOf(textTypes.TYPES),
  disabled: PropTypes.bool
};
TextLabel.defaultProps = {
  disabled: false
};
export default compose(TextLabel);